// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeSignatureApi = class EdgeSignatureApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param EmailSignatureTemplateRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async emailSignatureTemplateCreateEnvelope(EmailSignatureTemplateRequest, x_program_id) {
        const _url_ = '/edge/signature/v1/EmailSignatureTemplate/CreateEnvelope';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'EmailSignatureTemplateRequest' is not null or undefined
        if (EmailSignatureTemplateRequest === null || EmailSignatureTemplateRequest === undefined) {
            throw new Error('Required parameter EmailSignatureTemplateRequest was null or undefined when calling emailSignatureTemplateCreateEnvelope.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(EmailSignatureTemplateRequest, "EmailSignatureTemplateRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SignatureV1EmailSignatureTemplateCreateEnvelopeCreateEnvelopeResponse");
        }
        return response;
    }
    /**
     *
     * @param IEnvelopeResendRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async envelopeResend(IEnvelopeResendRequest, x_program_id) {
        const _url_ = '/edge/signature/v1/Envelope/Resend';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'IEnvelopeResendRequest' is not null or undefined
        if (IEnvelopeResendRequest === null || IEnvelopeResendRequest === undefined) {
            throw new Error('Required parameter IEnvelopeResendRequest was null or undefined when calling envelopeResend.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(IEnvelopeResendRequest, "IEnvelopeResendRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SignatureV1EnvelopeResendResendResponse");
        }
        return response;
    }
    /**
     *
     * @param IEnvelopeResendLatestRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async envelopeResendLatest(IEnvelopeResendLatestRequest, x_program_id) {
        const _url_ = '/edge/signature/v1/Envelope/ResendLatest';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'IEnvelopeResendLatestRequest' is not null or undefined
        if (IEnvelopeResendLatestRequest === null || IEnvelopeResendLatestRequest === undefined) {
            throw new Error('Required parameter IEnvelopeResendLatestRequest was null or undefined when calling envelopeResendLatest.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(IEnvelopeResendLatestRequest, "IEnvelopeResendLatestRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SignatureV1EnvelopeResendLatestResendLatestResponse");
        }
        return response;
    }
    /**
     *
     * @param GetRecipientViewRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async recipientViewRequestUrl(GetRecipientViewRequest, x_program_id) {
        const _url_ = '/edge/signature/v1/RecipientView/RequestURL';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetRecipientViewRequest' is not null or undefined
        if (GetRecipientViewRequest === null || GetRecipientViewRequest === undefined) {
            throw new Error('Required parameter GetRecipientViewRequest was null or undefined when calling recipientViewRequestUrl.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetRecipientViewRequest, "GetRecipientViewRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SignatureV1RecipientViewRequestUrlRequestUrlResponse");
        }
        return response;
    }
};
EdgeSignatureApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeSignatureApi);
export { EdgeSignatureApi };
//# sourceMappingURL=edgeSignatureApi.js.map